<template>
  <v-container class="pa-0 ma-0" id="mainhomecontainer" fluid>
    <v-card class="overview" elevation="0">
      <v-card-title class="pa-0">
        <v-container  class="pb-0">
          <!-- <v-row>
            <v-col
              cols="12"
              md="12"
              class="dashboard-title"

            >
              juZZap
              <br />
              <span class style="font-size:16px;">A NEW PARADIGM</span>
            </v-col>
          </v-row> -->
        </v-container>

      </v-card-title>
      <v-card-text class="mb-auto pa-0">
        <v-container fluid class="pb-0">
        <!-- <v-row>
          <v-col cols="12" md="12" sm="12" class="text-center title-clamped-1">
            <p>{{storeBusiness.businessName}}</p>
          </v-col>
        </v-row> -->
        </v-container>
        <!-- START OF DATA            -->
        <!-- <v-container class="">
          <v-row>
              <v-col cols="12" md="12" class="pb-1 text-center  justify-center">
                  <v-row class="true-center">{{$t('zz_activity_report')}}</v-row>
                  <v-row class="true-center dashboard-title-2">{{$t('zz_real-time-data')}}</v-row><br>
                  <br>
              </v-col>
          </v-row>
          <v-card-text>
              <div class="container">
                  <v-row>
                    <v-col cols="12" md="12" sm="12">
                      <v-row>
                        <v-col class="col-md-4">
                            <div class="profile-card-6"><img src="https://data.whicdn.com/images/304556718/original.gif">
                                <div class="profile-name">

                                  <span class="stat-number-1">
                                    {{uniquevisitorstoday}}
                                  </span>

                                  <span class="stat-number-2">
                                      &#8680; </span>
                                  <span class="stat-number-2">
                                    {{totalpagevisitstoday}}<br>
                                  </span>

                                  <span class="title-clamped-2">{{$t('zz_visitor_today')}}</span>
                                </div>
                                <div class="profile-position">
                                    <p>
                                        <br>{{$t('zz_visitor_unique')}} &#8680; {{$t('zz_visitor_total')}}<br><br>
                                        <span class="running-total">{{$t('zz_spend')}} {{(parseFloat (uniquevisitorstoday) * 0.025).toFixed(2)}}€<br>  </span>
                                    </p>
                                </div>
                            </div>
                        </v-col>
                        <v-col class="col-md-4">
                            <div class="profile-card-6"><img src="https://i.pinimg.com/originals/de/3f/d4/de3fd4e31317d724040d50c8330af12f.gif">
                                <div class="profile-name">{{uniquevisitorsthisweek}}<span style="font-weight: 300"></span><span class="stat-number-2"> &#8680; {{totalpagevisitsthisweek}}<br></span>
                                    <span class="title-clamped-2">{{$t('zz_visitor_this_week')}}</span>
                                </div>
                                <div class="profile-position">
                                    <p>
                                        <br>{{$t('zz_visitor_unique')}} &#8680; {{$t('zz_visitor_total')}}<br><br>
                                        <span class="running-total">{{$t('zz_spend')}} {{(parseFloat (uniquevisitorsthisweek) * 0.025).toFixed(2)}}€<br>  </span>
                                    </p>
                                </div>
                            </div>
                        </v-col>
                        <v-col class="col-md-4">
                            <div class="profile-card-6"><img src="https://i.pinimg.com/originals/41/6d/e1/416de1f8e82a223ec259a27a274c65fe.gif">
                                <div class="profile-name">{{uniquevisitorsthismonth}}<span style="font-weight: 300"></span><span class="stat-number-2"> &#8680; {{totalpagevisitsthismonth}}<br></span>
                                    <span class="title-clamped-2">{{$t('zz_visitor_this_month')}}</span>
                                </div>
                                <div class="profile-position">
                                    <p>
                                        <br>{{$t('zz_visitor_unique')}} &#8680; {{$t('zz_visitor_total')}}<br><br>
                                        <span class="running-total">{{$t('zz_spend')}} {{(parseFloat (uniquevisitorsthismonth) * 0.025).toFixed(2)}}€<br>  </span>
                                    </p>
                                </div>
                            </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
              </div>
          </v-card-text>
        </v-container> -->
      </v-card-text>
        <v-card-text class="mb-auto pa-0">
          <v-container>
            <v-row>
              <v-container class="true-center">
                <v-col cols="12" md="6" sm="12" class="pb-1">
                  <v-row class="true-center dashboard-title-3">{{$t('zz_your_PIN_Code')}}</v-row>
                  <v-row class="true-center pin-code">{{storeBusiness.businesscode}}</v-row>
                  <v-row class="true-center pt-5 pb-5">
                    <v-btn class="pa-3 py-5 white--text" :href="storeBusiness.pinfile" target="_blank" large color="#FE5800">
                        {{$t('zz_download_PDF')}}
                        <v-icon class="pa-6 my-3" large >
                          mdi-qrcode
                        </v-icon>
                    </v-btn>
                  </v-row>
                </v-col>
              </v-container>
            </v-row>

            <hr>

            <v-row class="mb-1">
              <v-col cols="12" md="12" class="text-center">
                <v-btn class="pa-3 pa-5 white--text" large color="#FE5800" @click="editbusinessprofile">
                  {{$t('zz_business_details')}}
                  <v-icon class="pa-6 my-3" large dark right>
                    mdi-domain
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="mb-1" v-if="bu.showfood==1">
              <v-col cols="12" md="12" class="text-center">
                <v-btn x-large outlined style="width:100%" color="primary" @click="foodmenu">
                  {{$t('zz_business_food_menu')}}
                  <v-icon class="pa-6 my-3" large right>mdi-food-apple-outline</v-icon>
                  <v-icon class="pa-6 my-3" large right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="mb-1" v-if="bu.showdrink==1">
              <v-col cols="12" md="12" class="text-center">
                <v-btn x-large outlined style="width:100%" color="primary" @click="drinkmenu">
                  {{$t('zz_business_drink_menu')}}
                  <v-icon class="pa-6 my-3" large right>mdi-glass-cocktail</v-icon>
                  <v-icon class="pa-6 my-3" large right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="mb-1" v-if="bu.showretail==1">
              <v-col cols="12" md="12" class="text-center">
                <v-btn x-large style="width:100%" outlined color="primary" @click="retailmenu">
                  {{$t('zz_retail_items')}}
                  <v-icon class="pa-6 my-3" large right>mdi-tag-multiple-outline</v-icon>
                  <v-icon class="pa-6 my-3" large right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <hr class="my-10">
            <p class="pa-3 text-center">{{$t('zz_show_hide_nav_buttons')}}</p>

            <v-row class="stackedrow">
              <v-card elevation="4" class="round">
                <v-col cols="12" sm="12" md="12" class="pa-0 ma-0">
                <v-row class="pa-0 px-5" align="center">
                    <v-col cols="8" md="8" class="pa-0 px-4 ma-0" style="font-size:20px">
                        <p>Food</p>
                        <!-- <v-icon  class="pa-6" large dark right>
                          mdi-food-apple-outline
                        </v-icon> -->
                    </v-col>
                    <v-col cols="4" md="4" class="pa-0 pt-3">
                      <div v-if="bu.showfood==1">
                        <v-switch label="" :input-value="shw"  @click="updateshowfood(0)"  color="success"></v-switch>
                      </div>
                      <div v-else>
                          <v-switch  color="" :input-value="nshw"  @click="updateshowfood(1)" ></v-switch>
                      </div>
                    </v-col>
                </v-row>
              </v-col>
              </v-card>

              <v-card elevation="4" class="round">
                <v-col cols="12" sm="12" md="12" class="pa-0 ma-0">
                <v-row class="pa-0 px-5" align="center">
                    <v-col cols="8" md="8" class="pa-0 px-4 ma-0" style="font-size:20px">
                        <p>Drink</p>
                        <!-- <v-icon  class="pa-6" large dark right>
                          mdi-glass-cocktail
                        </v-icon> -->
                    </v-col>
                    <v-col cols="4" md="4" class="pa-0 pt-3">
                      <div v-if="bu.showdrink==1">
                       <v-switch label="" :input-value="shw"  @click="updateshowdrink(0)" color="success"></v-switch>
                      </div>
                      <div v-else>
                       <v-switch  :input-value="nshw"  @click="updateshowdrink(1)" color=""></v-switch>
                      </div>
                    </v-col>
                </v-row>
              </v-col>
              </v-card>

              <v-card elevation="4" class="round">
                <v-col cols="12" sm="12" md="12" class="pa-0 ma-0">
                <v-row class="pa-0 px-5" align="center">
                    <v-col cols="8" md="8" class="pa-0 px-4 ma-0" style="font-size:20px">
                        <p>Retail</p>
                        <!-- <v-icon c lass="pa-6" large dark right>
                          mdi-tag-multiple-outline
                        </v-icon> -->
                    </v-col>
                    <v-col cols="4" md="4" class="pa-0 pt-3">
                      <div v-if="bu.showretail==1">
                        <v-switch label="" :input-value="shw"  @click="updateshowretail(0)"  color="success"></v-switch>
                      </div>
                      <div v-else>
                        <v-switch label="" :input-value="nshw"  @click="updateshowretail(1)"  color=""></v-switch>
                      </div>
                    </v-col>
                </v-row>
              </v-col>
              </v-card>

            </v-row>
          </v-container>
        </v-card-text>
    </v-card>
  </v-container>
</template>



<script>
import Vue from "vue";
import moment from "moment";
export default {
  props: {
    source: String
  },
  data: () => ({
    shw:true,
    nshw:false,
    passwordreset:false,
    valid: true,
    password:'',
    password_confirmation:'',
    ischange:false,
    codeError: false,
    businesscode2: "",
    businesscode1: "",
    businesscode3: "",
    juzzapLogo: require("@/assets/logo-Copy.png"),
    editIcon: require("@/assets/edit.png"),
    foodIcon: require("@/assets/dish.png"),
    drinkIcon:require("@/assets/drink.png"),
    valid: false,
    code: "",
    key: "",
    bannerImg: require("@/assets/overview-banner.jpg"),
    address: "",
    loading: false,
    storeBusiness: [],
    visitid: "",
    permited_internal_capacity: "0",
    permited_external_capacity: "0",
    editcapacity: 0,
    overlay: false,
    mobile: "",
    whatsapp: "",
    website: "",
    mondayopening: "0",
    mondayclosing: "0",
    tuesdayopening: "0",
    tuesdayclosing: "0",
    wednesdayopening: "0",
    wednesdayclosing: "0",
    thursdayopening: "0",
    thursdayclosing: "0",
    fridayopening: "0",
    fridayclosing: "0",
    saturdayopening: "0",
    saturdayclosing: "0",
    sundayopening: "0",
    sundayclosing: "0",
    mondayopening2: "0",
    mondayclosing2: "0",
    tuesdayopening2: "0",
    tuesdayclosing2: "0",
    wednesdayopening2: "0",
    wednesdayclosing2: "0",
    thursdayopening2: "0",
    thursdayclosing2: "0",
    fridayopening2: "0",
    fridayclosing2: "0",
    saturdayopening2: "0",
    saturdayclosing2: "0",
    sundayopening2: "0",
    sundayclosing2: "0",
    valid: true,
    businessName: "",
    businessType: "",
    email: "",
    phone: "",
    contactName: "",
    contactPosition: "",
    contactEmail: "",
    contactPhone: "",
    password: "",
    password_confirmation: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    addressLine4: "",
    postcode: "",
    types: [],
    confirmation: "",
    times: [
      { name: "Allways Open", value: "allwaysopen" },
      { name: "Closed", value: "0" },
      { name: "00:00", value: "00:00" },
      { name: "00:30", value: "00:30" },
      { name: "01:00", value: "01:00" },
      { name: "01:30", value: "01:30" },
      { name: "02:00", value: "02:00" },
      { name: "02:30", value: "02:30" },
      { name: "03:00", value: "03:00" },
      { name: "03:30", value: "03:30" },
      { name: "04:00", value: "04:00" },
      { name: "04:30", value: "04:30" },
      { name: "05:00", value: "05:00" },
      { name: "05:30", value: "05:30" },
      { name: "06:00", value: "06:00" },
      { name: "06:30", value: "06:30" },
      { name: "07:00", value: "07:00" },
      { name: "07:30", value: "07:30" },
      { name: "08:00", value: "08:00" },
      { name: "08:30", value: "08:30" },
      { name: "09:00", value: "09:00" },
      { name: "09:30", value: "09:30" },
      { name: "10:00", value: "10:00" },
      { name: "10:30", value: "10:30" },
      { name: "11:00", value: "11:00" },
      { name: "11:30", value: "11:30" },
      { name: "12:00", value: "12:00" },
      { name: "12:30", value: "12:30" },
      { name: "13:00", value: "13:00" },
      { name: "13:30", value: "13:30" },
      { name: "14:00", value: "14:00" },
      { name: "14:30", value: "14:30" },
      { name: "15:00", value: "15:00" },
      { name: "15:30", value: "15:30" },
      { name: "16:00", value: "16:00" },
      { name: "16:30", value: "16:30" },
      { name: "17:00", value: "17:00" },
      { name: "17:30", value: "17:30" },
      { name: "18:00", value: "18:00" },
      { name: "18:30", value: "18:30" },
      { name: "19:00", value: "19:00" },
      { name: "19:30", value: "19:30" },
      { name: "20:00", value: "20:00" },
      { name: "20:30", value: "20:30" },
      { name: "21:00", value: "21:00" },
      { name: "21:30", value: "21:30" },
      { name: "22:00", value: "22:00" },
      { name: "22:30", value: "22:30" },
      { name: "23:00", value: "23:00" },
      { name: "23:30", value: "23:30" }
    ],

    dictionary: {
      attributes: {
        permited_internal_capacity: "Permited internal capacity",
        permited_external_capacity: "Permited external capacity",
        email: "E-mail Address",
        businessName: "Business Name",
        businessType: "Business Type",
        confirmation: "Confirm your full acceptgance"
      },
      custom: {}
    },
    businessactivities: [],
    businessactivity_id: 0,
    externalcapacity: "",
    internalcapacity: "",
    country: "",
    isloggedin:false,
    uniquevisitorstoday:0,
    uniquevisitorsthismonth:0,
    uniquevisitorsthisweek:0,
    uniquevisitorslastmonth:0,
    uniquevisitorslastweek:0,
    totalpagevisitstoday:0,
    totalpagevisitstodaypin:0,
    totalpagevisitstodayqr:0,
    totalpagevisitstodaynfc:0,

    totalpagevisitsthisweek:0,
    totalpagevisitsthisweekpin:0,
    totalpagevisitsthisweeknfc:0,
    totalpagevisitsthisweekqr:0,

    totalpagevisitslastweek:0,
    totalpagevisitslastweekpin:0,
    totalpagevisitslastweeknfc:0,
    totalpagevisitslastweekqr:0,

    totalpagevisitsthismonth:0,
    totalpagevisitsthismonthpin:0,
    totalpagevisitsthismonthnfc:0,
    totalpagevisitsthismonthqr:0,

    totalpagevisitslastmonth:0,
    totalpagevisitslastmonthpin:0,
    totalpagevisitslastmonthnfc:0,
    totalpagevisitslastmonthqr:0,

    checkfooditemexist:0,
    checkitemdrinkexist:0,
    checkitemretailexist:0,
    showfood1:1,
    bu:[],

  }),
   computed: {
    isAuthorised() {
      return this.$store.getters.isLoggedin;
    },

  },
  created() {
    //    if (this.$route.params.key) {
    //   this.key = this.$route.params.key;
    //    }

    // this.getBusiness();
    if(localStorage.getItem('isLoggedin')=='true')
    {
        this.isloggedin=true;
    }else{
        this.isloggedin=false;
    }

    this.storeBusiness = JSON.parse(localStorage.getItem("business"));
    this.permited_internal_capacity = this.storeBusiness.permited_internal_capacity;
    this.permited_external_capacity = this.storeBusiness.permited_external_capacity;

    this.visitordata();
    this.fetchdata();
    setInterval(function(){this.visitordata},30000);
  },
  methods:
  {

    fetchdata()
    {
      this.$http
          .get(this.$apidomain+"businessdata/" + this.storeBusiness.id)
          .then(res => {
            this.bu = res.data.businesses;
            // localStorage.setItem("business", res.data.business);
            this.showfood1=res.data.businesses.showfood;
            this.loading = false;
          })
          .catch(err => {
            console.log(err.response);
          });
    },
    updateshowretail(showretail)
    {
        this.$http
              .post(this.$apidomain+"updateshowretail/"+this.storeBusiness.id,{showretail:showretail})
              .then(res => {
                  if(res.data.success==1)
                  {
                      // this.storeBusiness = res.data.business;

                      // this.storeBusiness.showfood=showfood;


                      this.$router.go('/');
                  }



              })
              .catch(err => {
                  console.log(err.response);
                  //this.overlay=false;

              });
    },

    updateshowdrink(showdrink)
    {
        this.$http
              .post(this.$apidomain+"updateshowdrink/"+this.storeBusiness.id,{showdrink:showdrink})
              .then(res => {
                  if(res.data.success==1)
                  {
                      // this.storeBusiness = res.data.business;

                      // this.storeBusiness.showfood=showfood;


                      this.$router.go('/');
                  }



              })
              .catch(err => {
                  console.log(err.response);
                  //this.overlay=false;

              });
    },
    updateshowfood(showfood)
    {
              this.$http
              .post(this.$apidomain+"updateshowfood/"+this.storeBusiness.id,{showfood:showfood})
              .then(res => {
                  if(res.data.success==1)
                  {
                      // this.storeBusiness = res.data.business;

                      // this.storeBusiness.showfood=showfood;


                      this.$router.go('/');
                  }



              })
              .catch(err => {
                  console.log(err.response);
                  //this.overlay=false;

              });

    },
    checkfooditemexists()
    {
        this.$http
        .get(
          this.$apidomain+"checkfooditemexist/" +this.storeBusiness.id

        )
        .then(res => {
          if(res.data.success)
          {

            this.checkfooditemexist=res.data.success;

            return 1;
          }

        })
        .catch(err => {
            console.log(err.response);
          });

    },

    checkdrinkitemexist()
    {
        this.$http
        .get(
          this.$apidomain+"checkfooditemexist/" +this.storeBusiness.id

        )
        .then(res => {
          if(res.data.success)
          {

            this.checkitemdrinkexist=res.data.items;

            return res.data.items;
          }

        })
        .catch(err => {
            console.log(err.response);
          });

    },

    checkretailitemexist()
    {
        this.$http
        .get(
          this.$apidomain+"checkretailitemexist/" +this.storeBusiness.id

        )
        .then(res => {
          if(res.data.success)
          {

            this.checkitemretailexist=res.data.items;

            return res.data.items;
          }

        })
        .catch(err => {
            console.log(err.response);
          });

    },

    visitordata()
    {

       this.$http
          .get(
            this.$apidomain+"visitors/" +
              this.storeBusiness.id
          )
          .then(res => {
            if (res.data.success)
            {
              this.uniquevisitorstoday = res.data.uniquevisitorstoday;
              this.uniquevisitorsthisweek = res.data.uniquevisitorsthisweek;
              this.uniquevisitorslastweek = res.data.uniquevisitorslastweek;
              this.uniquevisitorsthismonth = res.data.uniquevisitorsthismonth;
              this.uniquevisitorslastmonth = res.data.uniquevisitorslastmonth;

              this.totalpagevisitstoday=res.data.totalpagevisitstoday;
                    this.totalpagevisitstodaypin=res.data.totalpagevisitstodaypin;
                    this.totalpagevisitstodaynfc=res.data.totalpagevisitstodaynfc;
                    this.totalpagevisitstodayqr=res.data.totalpagevisitstodayqr;

                    this.totalpagevisitsthisweek=res.data.totalpagevisitsthisweek;
                    this.totalpagevisitsthisweekpin=res.data.totalpagevisitsthisweekpin;
                    this.totalpagevisitsthisweeknfc=res.data.totalpagevisitsthisweeknfc;
                    this.totalpagevisitsthisweekqr=res.data.totalpagevisitsthisweekqr;

                    this.totalpagevisitslastweek=res.data.totalpagevisitslastweek;
                    this.totalpagevisitslastweekpin=res.data.totalpagevisitslastweekpin;
                    this.totalpagevisitslastweeknfc=res.data.totalpagevisitslastweeknfc;
                    this.totalpagevisitslastweekqr=res.data.totalpagevisitslastweekqr;

                    this.totalpagevisitsthismonth=res.data.totalpagevisitsthismonth;
                    this.totalpagevisitsthismonthpin=res.data.totalpagevisitsthismonthpin;
                    this.totalpagevisitsthismonthnfc=res.data.totalpagevisitsthismonthnfc;
                    this.totalpagevisitsthismonthqr=res.data.totalpagevisitsthismonthqr;

                    this.totalpagevisitslastmonth=res.data.totalpagevisitslastmonth;
                    this.totalpagevisitslastmonthpin=res.data.totalpagevisitslastmonthpin;
                    this.totalpagevisitslastmonthnfc=res.data.totalpagevisitslastmonthnfc;
                    this.totalpagevisitslastmonthqr=res.data.totalpagevisitslastmonthqr;


            }
          })
          .catch(err => {
            console.log(err.response);
          });
    },

    submitchangepassword() {

      if (this.$validator.validateAll()) {
          let fd = new FormData(document.getElementById('changepassword'));
          this.$http.post(this.$apidomain+'changepas',fd)
        .then(res=>{

          //this.logout();
          this.ischange=false;
          this.passwordreset=true;
          this.password='';
          this.password_confirmation='';
        })
        .catch(err=>{
          console.log(err.response);
        });
      }
    },
    downloadpinfile()
    {
        this.$http
          .get(
            this.$apidomain+"getbusinesspinfile/" +this.storeBusiness.id

          )
          .then(res => {
            if(res.data.success)
            {
              // this.$router.go(res.data.pfile);
              // window.location.href=res.data.pfile;


              // window.open(
              //   res.data.pfile,
              //   '_blank' // <- This is what makes it open in a new window.
              // );



            }
          })



    },
    editbusinessprofile() {
      //this.storeBusiness=JSON.parse(this.$store.getters.business);

      this.$router.push({
        name: "updatebusiness",
        params: { id: this.storeBusiness.id }
      });
    },

    foodmenu() {
      // this.$router.push({
      //   name: "businessfoodlist",
      //   params: { id: this.storeBusiness.id }
      // });
      // this.$router.push({
      //   name: "menuoption",
      //   params: { id: this.storeBusiness.id }
      // });
      this.$router.push({name:'food',params:{tag:  this.storeBusiness.businesscode,key:''}});
    },

    drinkmenu() {

      // this.$router.push({
      //   name: "businessdrinklist",
      //   params: { id: this.storeBusiness.id }
      // });
      this.$router.push({name:'drink',params:{tag:  this.storeBusiness.businesscode,key:''}});
    },
    retailmenu() {

      // this.$router.push({
      //   name: "businessdrinklist",
      //   params: { id: this.storeBusiness.id }
      // });
      this.$router.push({name:'retailitem',params:{tag:  this.storeBusiness.businesscode,key:''}});
    },

    submit() {
      let th = this;
      if (this.$validator.validateAll()) {
        let fd = new FormData(document.getElementById("addbusinesscapacity"));

        this.$http
          .post(
            this.$apidomain+"updatebusinesscapacity/" +
              this.storeBusiness.id,
            fd
          )
          .then(res => {
            if (res.data.success) {
              this.storeBusiness = res.data.business;
              this.$store
                .dispatch("assignBusiness", JSON.stringify(this.storeBusiness))
                .then(() => {});
              this.editcapacity = 0;
              this.permited_internal_capacity = this.storeBusiness.permited_internal_capacity;
              this.permited_external_capacity = this.storeBusiness.permited_external_capacity;
            }
          })
          .catch(err => {
            console.log(err.response);
          });
      }
    },

    changebusinesscode() {
      this.$http
        .get(
          this.$apidomain+"changebusinesscode/" +
            this.storeBusiness.id
        )
        .then(res => {
          if (res.data.success) {
            this.storeBusiness = res.data.business;
            this.$store
              .dispatch("assignBusiness", JSON.stringify(this.storeBusiness))
              .then(() => {});
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    leave() {
      this.$http
        .get(this.$apidomain+"leavebusiness/" + this.visitid)
        .then(res => {
          this.businessvisit = res.data.businessvisit;
          if (!this.$isloggedin) {
            this.$router.push("/login");
          } else {
            //profile if login name,address edit
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    getBusiness() {
      console.log("userkey " + localStorage.getItem("userkey"));
      if (localStorage.getItem("isLoggedin") == "true") {
        this.$http
          .get(this.$apidomain+"businessdatahome/" + this.code)
          .then(res => {
            this.business = res.data.business;
            this.visitid = this.business.uservisitid;

            this.loading = false;
          })
          .catch(err => {
            console.log(err.response);
          });
      } else {
        let url = "";
        if (localStorage.getItem("userkey")) {
          url =
            this.$apidomain+"businessdataguest/" +
            this.code +
            "/" +
            localStorage.getItem("userkey");
        } else {
          url = this.$apidomain+"businessdataguest/" + this.code;
        }

        this.$http
          .get(url)
          .then(res => {
            this.business = res.data.business;
            localStorage.setItem("userkey", this.business.notloggedinkey);
            this.visitid = this.business.uservisitid;
            this.loading = false;
          })
          .catch(err => {
            console.log(err.response);
          });
      }
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    }
  }
};
</script>
<style scoped>

.bgroundC{
  background-color: crimson !important;
}

.bgroundC2{
  background-color: rgb(250, 2, 188) !important;
}

.bgroundC3{
  background-color: rgb(13, 224, 108) !important;
}

.bgroundC4{
  background-color: rgb(147, 13, 224) !important;
}

.bgroundC5{
  background-color: rgb(13, 224, 206) !important;
}

.dashboard-title{
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  color: #fe5800;
}

.dashboard-title-2{
  font-size: 24px;
  font-weight: 400;
  text-align: center;
  color: #1b1b1b;
  padding-top: 15px;
  padding-bottom: 15px;
  text-align: center;

  /* background-color: #58d683; */
}
.dashboard-title-3{
  font-size: 18px;
  font-weight: 800;
  text-align: center;
  color: #1b1b1b;
  padding-top: 15px;
  padding-bottom: 15px;
  text-align: center;

  /* background-color: #58d683; */
}
.full-width-column-centered{
  justify-content: center;
}
.title-clamped-1{
    font-size: clamp(40px, 2vw, 70px);
    font-weight: 500;
    line-height: 1.2;
    text-transform: uppercase;
    /* background-color: #FE5800; */
}
.title-clamped-2{
    font-size: clamp(30px, 2vw, 70px);
    font-weight: 800;
    /* line-height: 1; */
    text-transform: uppercase;
    /* background-color: #FE5800; */

}

.business-name-top{
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  color: #252525;
  padding-bottom: 10px;
}

.pin-code{
  font-size: clamp(60px, 15vw, 90px) !important;
  /* font-weight: 800; */
  color:#fe5800;
  padding: 40px;
  /* padding-top: 50px; */
  border: #FE5800;
  border-width: 10px;
  border-style: solid;
  /* max-width: 300px; */
  display: grid;
  place-items: center;
}

.dashboard-buttons{
  max-width: 300px !important;
  align-content: center;
  justify-content: center;
}


.p-10 {
  padding: 10px;
}
.pwa-content {
  margin-top: -63px;
}
#mainhomecontainer.container {
  width: 100%;
  max-width: 100%;
}
#mainhomecontainer.container .heading {
  color: #fff;
}
.topbg {
  background: #fe5800;
}
    /* =============CODEPEN CSS=================== */

.container-fluid,
.container {
    max-width: 1200px;
}

.card-container {
    padding: 100px 0px;
    -webkit-perspective: 1000;
    perspective: 1000;
}

.profile-card-1 {
    background-color: #FFF;
    border-radius: 10px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    /* background-image: url(../img/profile-bg-1.jpg); */
    background-position: center;
    padding-top: 100px;
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    max-width: 300px;
}

.profile-card-1 .profile-content {
    position: relative;
    background-color: #FFF;
    padding: 70px 20px 20px 20px;
    text-align: center;
}

.profile-card-1 .profile-img {
    position: absolute;
    height: 100px;
    left: 0px;
    right: 0px;
    z-index: 10;
    top: -50px;
    transition: all 0.25s linear;
    transform-style: preserve-3d;
}

.profile-card-1 .profile-img img {
    height: 100px;
    margin: auto;
    border-radius: 50%;
    border: 5px solid #FFF;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.profile-card-1 .profile-name {
    font-size: 18px;
    font-weight: bold;
    color: #021830;
}

.profile-card-1 .profile-address {
    color: #777;
    font-size: 12px;
    margin: 0px 0px 15px 0px;
}

.profile-card-1 .profile-description {
    font-size: 13px;
    padding: 5px 10px;
    color: #777;
}

.profile-card-1 .profile-icons .fa {
    margin: 5px;
    color: #777;
}

.profile-card-1:hover {
    box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
}

.profile-card-1:hover .profile-img {
    transform: rotateY(180deg);
}

.profile-card-2 {
    max-width: 300px;
    background-color: #FFF;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    background-position: center;
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    border-radius: 10px;
}

.profile-card-2 img {
    transition: all linear 0.25s;
}

.profile-card-2 .profile-name {
    position: absolute;
    left: 30px;
    bottom: 70px;
    font-size: 30px;
    color: #FFF;
    text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
    font-weight: bold;
    transition: all linear 0.25s;
}

.profile-card-2 .profile-icons {
    position: absolute;
    bottom: 30px;
    right: 30px;
    color: #FFF;
    transition: all linear 0.25s;
}

.profile-card-2 .profile-username {
    position: absolute;
    bottom: 50px;
    left: 30px;
    color: #FFF;
    font-size: 13px;
    transition: all linear 0.25s;
}

.profile-card-2 .profile-icons .fa {
    margin: 5px;
}

.profile-card-2:hover img {
    filter: grayscale(100%);
}

.profile-card-2:hover .profile-name {
    bottom: 80px;
}

.profile-card-2:hover .profile-username {
    bottom: 60px;
}

.profile-card-2:hover .profile-icons {
    right: 40px;
}

.profile-card-3 {
    background-color: #FFF;
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    padding: 25px 15px;
}

.profile-card-3 .profile-name {
    font-weight: bold;
    color: #21304e;
}

.profile-card-3 .profile-location {
    color: #999;
    font-size: 13px;
    font-weight: 600;
}

.profile-card-3 img {
    height: 100px;
    width: 100px;
    object-fit: cover;
    margin: 10px auto;
    border-radius: 50%;
    transition: all linear 0.25s;
}

.profile-card-3 .profile-description {
    font-size: 13px;
    color: #777;
    padding: 10px;
}

.profile-card-3 .profile-icons {
    margin: 15px 0px;
}

.profile-card-3 .profile-icons .fa {
    color: #fe455a;
    margin: 0px 5px;
}

.profile-card-3:hover img {
    height: 110px;
    width: 110px;
    margin: 5px auto;
}

.profile-card-4 {
    max-width: 300px;
    background-color: #FFF;
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
}

.profile-card-4 img {
    transition: all 0.25s linear;
}

.profile-card-4 .profile-content {
    position: relative;
    padding: 15px;
    background-color: #FFF;
}

.profile-card-4 .profile-name {
    font-weight: bold;
    position: absolute;
    left: 0px;
    right: 0px;
    top: -70px;
    color: #FFF;
    font-size: 17px;
}

.profile-card-4 .profile-name p {
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 1.5px;
}

.profile-card-4 .profile-description {
    color: #777;
    font-size: 12px;
    padding: 10px;
}

.profile-card-4 .profile-overview {
    padding: 15px 0px;
}

.profile-card-4 .profile-overview p {
    font-size: 10px;
    font-weight: 600;
    color: #777;
}

.profile-card-4 .profile-overview h4 {
    color: #273751;
    font-weight: bold;
}

.profile-card-4 .profile-content::before {
    content: "";
    position: absolute;
    height: 20px;
    top: -10px;
    left: 0px;
    right: 0px;
    background-color: #FFF;
    z-index: 0;
    transform: skewY(3deg);
}

.profile-card-4:hover img {
    transform: rotate(5deg) scale(1.1, 1.1);
    filter: brightness(110%);
}

.profile-card-5 {
    max-width: 300px;
    background-color: #FFF;
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    padding: 50px 15px 25px 15px;
}

.profile-card-5 img {
    height: 100px;
    width: 100px;
    object-fit: cover;
    margin: 10px auto;
    border-radius: 50%;
    transition: all linear 0.25s;
    position: relative;
}

.profile-card-5::before {
    content: "";
    position: absolute;
    top: -60px;
    right: 0px;
    left: 0px;
    height: 170px;
    background-color: #4fb96e;
    transform: skewY(-20deg);
}

.profile-card-5 .profile-name {
    padding-top: 15px;
    font-weight: bold;
    color: #333;
}

.profile-card-5 .profile-designation {
    font-size: 13px;
    color: #777;
}

.profile-card-3 .profile-location {
    color: #999;
    font-size: 13px;
    font-weight: 600;
}

.profile-card-5 .profile-description {
    font-size: 13px;
    color: #777;
    padding: 10px;
}

.profile-card-5 .profile-overview {
    padding: 15px 0px;
}

.profile-card-5 .profile-overview p {
    color: #777;
    font-size: 13px;
}

.profile-card-5 .profile-overview h2 {
    font-weight: bold;
    color: #1e2832;
}

.profile-card-5 .profile-icons .fa {
    margin: 7px;
    color: #4fb96e;
}

.profile-card-5:hover img {
    transform: rotate(-5deg);
}

.profile-card-6 {
    max-width: 400px;
    max-height: 200px;
    background-color: #FFF;
    border-radius: 10px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
}

.profile-card-6 img {
    transition: all 0.15s linear;
}

.profile-card-6 .lh-1{
    line-height: 1;
}

.profile-card-6 .profile-name {
    position: absolute;
    border-radius: 10px;
    top: 10px;
    left: 10px;
    right: 35px;
    font-size: 45px;
    font-weight: 800;
    line-height: 1;
    color: #FFF;
    padding: 15px 20px;
    background: linear-gradient(150deg, rgba(241, 6, 6, 0.75) 50%, rgba(253, 101, 0, 0) 50%);
    transition: all 0.15s linear;
}


.profile-card-6 .profile-position {
    position: absolute;
    color: rgb(255, 255, 255);
    left: 30px;
    top: 100px;
    transition: all 0.15s linear;
}

.profile-card-6 .profile-overview {
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 50%, rgba(255, 255, 0, 0));
    color: #FFF;
    padding: 50px 0px 20px 0px;
    transition: all 0.15s linear;
}

.profile-card-6 .profile-overview h3 {
    font-weight: bold;
}

.profile-card-6 .profile-overview p {
    color: rgb(255, 255, 255);
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 10px;
}

.profile-card-6 .stat-number{
    color: #fff;
    font-size: 20px;
    font-weight: 800;
    padding: 20px;
}

.profile-card-6 .stat-number-2{
    color: #fff;
    font-size: 25px;
    font-weight: 600;

}

.profile-card-6 .running-total{
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    justify-content: flex-end;
    padding-bottom: 20px;

}


.profile-card-6 .stat-label{
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
}

.profile-card-6:hover img {
    filter: brightness(80%);
}

.profile-card-6:hover .profile-name {
    padding-left: 25px;
    padding-top: 20px;
}

.profile-card-6:hover .profile-position {
    left: 40px;
}

.profile-card-6:hover .profile-overview {
    padding-bottom: 25px;
}

.profile-card-7 {
    background-color: #FFF;
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
}

.profile-card-7 .profile-content {
    padding: 60px 30px 30px 30px;
    background-color: #FFF;
    position: relative;
}

.profile-card-7 .profile-content img {
    position: absolute;
    height: 80px;
    width: 80px;
    border-radius: 50%;
    top: -40px;
    border: 5px solid #FFF;
}

.profile-card-7 .profile-content .profile-name {
    position: absolute;
    font-size: 17px;
    font-weight: bold;
    top: -35px;
    left: 125px;
    color: #FFF;
}

.profile-card-7 .profile-overview {
    padding: 5px 0px;
}

.profile-card-7 .profile-overview p {
    color: #777;
    font-size: 11px;
    font-weight: 600;
}

.profile-card-7 .profile-overview h5 {
    color: #142437;
    font-weight: bold;
}

.profile-card-8 {
    background: linear-gradient(#09121c, #36445a);
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    transition: all 0.25s linear;
}

.profile-card-8 .profile-name {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 25px;
    color: #58d683;
    font-size: 17px;
    font-weight: bold;
}

.profile-card-8 .profile-designation {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 50px;
    color: #FFF;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 1px;
}

.profile-card-8 .profile-icons {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 80px;
    color: rgba(255, 255, 255, 0.7);
}

.profile-card-8 .profile-icons .fa {
    margin: 5px;
}

.profile-card-8:hover {
    transform: scale(1.05, 1.05);
}

.profile-card-9 {
    border-radius: 10px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    padding: 30px 15px;
    background-color: #FFF;
    transition: all 0.25s linear;
}

.profile-card-9 img {
    height: 120px;
    width: 120px;
    border-radius: 50%;
    margin: 10px auto;
}

.profile-card-9 .profile-name {
    font-size: 15px;
    color: #3249b9;
    font-weight: 600;
}

.profile-card-9 .profile-designation {
    font-size: 13px;
    color: #777;
}

.profile-card-9 .profile-description {
    padding: 10px;
    font-size: 13px;
    color: #777;
    margin: 15px 0px;
    background-color: #F1F2F3;
    border-radius: 5px;
}

.profile-card-9 a {
    padding: 10px 15px;
    background-color: #3249b9;
    color: #FFF;
    font-size: 11px;
    border-radius: 25px;
}

.profile-card-9:hover {
    transform: scale(1.05, 1.05);
}

.profile-card-10 {
    border-radius: 5px;
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    margin: 10px auto;
    cursor: pointer;
    padding: 30px 15px;
    background-color: #1f2124;
    color: #EEE;
}

.profile-card-10 img {
    margin: 10px auto;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 10px solid transparent;
    box-shadow: 0px 0px 0px 2px #64c17b;
    transition: all 0.25s linear;
}

.profile-card-10 .profile-name {
    color: #FFF;
    font-weight: bold;
    font-size: 17px;
}

.profile-card-10 .profile-location {
    font-size: 13px;
    opacity: 0.7;
}

.profile-card-10 .profile-description {
    padding: 10px;
    font-size: 13px;
}

.profile-card-10 .profile-icons .fa {
    color: #ffc75e;
    margin: 10px;
}

.profile-card-10:hover img {
    transform: scale(1.1);
}
.max-350{
  max-width: 350px;
}
.stackedrow{
  display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.spacedout{
  justify-content: space-around;
  padding-bottom: 25px;
  flex: 1 1 150px; /*  Stretching:
  flex: 0 1 150px; /*  No stretching: */
  margin: 5px;
}
.round{
  border-radius: 10px;
  padding: 5px;
  margin: 25px;
}

</style>
